import React, {useEffect, useRef, useState} from 'react';
import {Avatar, Box, Sheet, Stack, Typography} from '@mui/joy';
import {ProjectRepository} from "../repository/ProjectRepository";
import {useParams} from "react-router";
import {ExperienceModel} from "../model/experience";
import LoadingPage from "./Loading";
import {AddLocation, LocationCity, Map, MyLocation, ShareLocation} from "@mui/icons-material";
import TimeOutPage from './TimeOut';

function ExperiencePage() {
    const {key} = useParams()
    const repo = new ProjectRepository()
    const [experience, setExperience] = useState<ExperienceModel>(new ExperienceModel());
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        if (key) {
            repo.getAllExperience().then(value => {
                if (value.length > 0) {
                    const experienceFind: ExperienceModel = value
                        .find(value1 => value1.title
                            .concat('-' + value1.company.concat('-' + value1.startDate))
                            .toLowerCase()
                            .replaceAll(' ', '-')
                            .localeCompare(key) == 0) as ExperienceModel
                    setExperience(experienceFind)
                }
            }).catch(reason => setError(true));
        }
    }, [])

    const startDate = experience.startDate.substring(experience.startDate.indexOf('-') + 1).replaceAll('-', '/');
    const endDate = (experience.endDate.indexOf('-') >= 0)
        ? experience.endDate.substring(experience.endDate.indexOf('-') + 1).replaceAll('-', '/')
        : experience.endDate;

    return (
        <Box paddingTop={2} padding={2} paddingX={{xs: 2, md: 6}}
             sx={{bgcolor: 'background.surface', minHeight: '100vh'}}>
            {!(experience.title.length > 0) && (
                <LoadingPage/>
            )}
            {(experience.title.length > 0 && error) && (
                <TimeOutPage/>
            )}
            {(experience.title.length > 0 && !error) && (
                <Sheet sx={{minHeight: {xs: '95vh', md: '67vh'}, paddingY: 0, borderRadius: 8}}>
                    <Stack direction='row' spacing={2} alignItems='start'>
                        <Stack maxWidth='100%' alignContent="center" spacing={0} justifyContent="center"
                               direction="column">
                            <Typography color="neutral" level='body-md'>{startDate} - {endDate}</Typography>
                            <Typography level="title-lg" color='primary'
                                        fontWeight='lg'> {experience.title}</Typography>
                            <Typography level='title-md' fontWeight='lg'>{experience.company}</Typography>
                            <Typography startDecorator={<Map/>} level='body-md'>{experience.address}</Typography>
                            <br/>
                            {(experience.description.length > 0) && (
                                <Typography>{experience.description}<br/><br/></Typography>
                            )}
                            <Typography fontWeight='lg'>Responsibilities: </Typography>
                            <Stack direction='column' spacing={1}>
                                {
                                    experience.responsibilities.map(value => (
                                        <Typography alignItems='start' startDecorator={'•'}>{value}</Typography>))
                                }
                            </Stack>
                            <br/>
                            <Typography fontWeight='lg'>Technologies used: </Typography>
                            <Typography>{experience.technologiesUsed.join(" • ")} </Typography>
                        </Stack>
                    </Stack>
                </Sheet>
            )}
        </Box>
    );
}

export default ExperiencePage;